import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnInit, TemplateRef } from '@angular/core';
import { AddressTypes } from '../../../modules/security/models/user.model';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
export class DoctorAddressGridComponent {
    constructor(translocoService, modalServide, fb, userService, treatmentsService, cd, snackBar) {
        this.translocoService = translocoService;
        this.modalServide = modalServide;
        this.fb = fb;
        this.userService = userService;
        this.treatmentsService = treatmentsService;
        this.cd = cd;
        this.snackBar = snackBar;
        this.addresses = [];
        this.disabledAddButton = false;
        this.saveAddress = new EventEmitter();
        this.isLoading = true;
        this.isRequired = false;
        this.isEdit = false;
        this.tempAddresses = [];
        this.options = {
            types: ['address']
        };
        this.selectedRowdAddress = false;
        this.unlockedGoogleMaps = false;
        this.loadingDeleteStatus = -1;
        this.loadingEditStatus = -1;
        this.isUsaVersion = environment.isUsaVersion;
    }
    ngOnInit() {
        this.currentUser = this.userService.readUserFromLocalStorage();
        //fix
        const carrierName = this.isUsaVersion ? 'FedEx' : '';
        this.addressCreateUpdateForm = this.fb.group({
            idAddress: ['', [Validators.required]],
            addressType: ['', [Validators.required]],
            addressTypeValue: [''],
            activityName: ['', [Validators.required]],
            address: ['', [Validators.required]],
            addressTemp: [''],
            zipCode: [{ value: '', disabled: !this.allowEditAddressInfo() }],
            city: [{ value: '', disabled: !this.allowEditAddressInfo() }],
            vat: [''],
            countryCode: [{ value: '', disabled: !this.allowEditAddressInfo() }],
            location: [{ value: '', disabled: !this.allowEditAddressInfo() }],
            phone: [''],
            carrierName: [''],
            notes: [''],
            blockPhases1: [false],
            blockNextPhases: [false],
        });
        this.addressCreateUpdateForm.controls.addressType.valueChanges.subscribe(value => {
            if (value === 'I') {
                this.addressCreateUpdateForm.controls.vat.setValidators(Validators.required);
                this.addressCreateUpdateForm.controls.vat.setValue(this.addressCreateUpdateForm.controls.vat.value);
            }
            else {
                this.addressCreateUpdateForm.controls.vat.clearValidators();
                this.addressCreateUpdateForm.controls.vat.setValue(this.addressCreateUpdateForm.controls.vat.value);
            }
        });
        this.isLoading = true;
        this.defineColumns();
        this.recalculate();
        this.translocoService.langChanges$.subscribe(() => {
            this.translocoService.selectTranslate('REGISTRATION.COLUMNS.AddressTypeColumn').subscribe((value) => {
                this.defineColumns();
            });
        });
    }
    allowEditAddressInfo() {
        return this.currentUser.userGroup === 'ED' || this.currentUser.role === 'EX' && this.currentUser.executiveArea === 'A';
    }
    ngAfterViewInit() {
        const interval = setInterval(() => {
            window.dispatchEvent(new Event('resize'));
        }, 10);
        setTimeout(() => {
            clearInterval(interval);
        }, 2500);
    }
    handleAddressChange(address) {
        const getAddress = (address_components) => {
            let street = '';
            let streetNumber = '';
            address_components.forEach(comp => {
                if (comp.types.includes('street_number')) {
                    streetNumber = comp.long_name;
                }
                if (comp.types.includes('route')) {
                    street = comp.long_name;
                }
            });
            return `${street}${streetNumber ? ',' : ''} ${streetNumber}`;
        };
        const getLongName = (address_components, fieldName, fieldType = 'long_name') => {
            let value = '';
            address_components.forEach(comp => {
                if (comp.types.includes(fieldName)) {
                    value = comp[fieldType];
                }
            });
            return value;
        };
        this.addressCreateUpdateForm.controls.address.setValue(getAddress(address.address_components));
        this.addressCreateUpdateForm.controls.addressTemp.setValue(getAddress(address.address_components));
        this.addressCreateUpdateForm.controls.city.setValue(getLongName(address.address_components, 'locality'));
        this.addressCreateUpdateForm.controls.zipCode.setValue(getLongName(address.address_components, 'postal_code'));
        this.addressCreateUpdateForm.controls.countryCode.setValue(getLongName(address.address_components, 'country', 'short_name'));
        this.addressCreateUpdateForm.controls.location.setValue(getLongName(address.address_components, 'administrative_area_level_2', 'short_name'));
        if (this.addressCreateUpdateForm.controls.carrierName.value === '') {
            this.addressCreateUpdateForm.controls.carrierName.setValue('FedEx');
        }
    }
    showCarrier() {
        return this.currentUser.role === 'US';
    }
    allowEditCarrier() {
        return this.currentUser.role === 'US' &&
            (this.currentUser.userGroup === 'ED' || this.currentUser.userGroup === 'SH');
    }
    allowEditCarrierForShipping() {
        if (this.addressCreateUpdateForm.controls.addressType.value !== 'S') {
            return false;
        }
        return (this.addressCreateUpdateForm.controls.addressType.value === 'S' &&
            this.currentUser.role === 'US' &&
            this.currentUser.userGroup === 'SH');
    }
    showWarning(row) {
        return (this.currentUser.role === 'US' || this.currentUser.role === 'EX' || this.currentUser.role === 'SA') &&
            (row.blockNextPhases || row.blockPhases1);
    }
    defineColumns() {
        let cityLabel = 'REGISTRATION.COLUMNS.CityColumn';
        let stateLabel = 'REGISTRATION.COLUMNS.CountryColumn';
        let zipcodeLabel = 'REGISTRATION.COLUMNS.ZipCodeColumn';
        let vatLabel = 'REGISTRATION.VatNumberPlaceHolder';
        if (this.isUsaVersion) {
            cityLabel = 'REGISTRATION.COLUMNS.CityColumnUSA';
            stateLabel = 'REGISTRATION.COLUMNS.CountryColumnUSA';
            zipcodeLabel = 'REGISTRATION.COLUMNS.ZipCodeColumnUSA';
            vatLabel = 'REGISTRATION.VatNumberPlaceHolderUSA2';
        }
        this.ngxColumns = [
            { prop: 'addressType', name: this.translocoService.translate('REGISTRATION.COLUMNS.AddressTypeColumn'),
                width: 100, headerTemplate: this.hdrTpl, cellTemplate: this.addressTypeTpl },
            { prop: 'activityName', name: this.translocoService.translate('REGISTRATION.COLUMNS.ActivityNameColumn'),
                width: 140, headerTemplate: this.hdrTpl, cellTemplate: this.activityNameTpl },
            { prop: 'address', name: this.translocoService.translate('REGISTRATION.COLUMNS.AddressColumns'),
                width: 120, headerTemplate: this.hdrTpl, cellTemplate: this.addressTpl },
            { prop: 'city', name: this.translocoService.translate(cityLabel),
                width: 110, headerTemplate: this.hdrTpl, cellTemplate: this.cityTpl },
            { prop: 'country', name: this.translocoService.translate(stateLabel),
                width: 110, headerTemplate: this.hdrTpl, cellTemplate: this.autocompleteTpl },
            { prop: 'zipCode', name: this.translocoService.translate(zipcodeLabel),
                width: 110, headerTemplate: this.hdrTpl, cellTemplate: this.zipCodeTpl },
            { prop: 'phone', name: this.translocoService.translate('REGISTRATION.COLUMNS.PhoneColumn'),
                width: 100, headerTemplate: this.hdrTpl, cellTemplate: this.phoneTpl },
            { prop: 'vat', name: this.translocoService.translate(vatLabel),
                width: 100, headerTemplate: this.hdrTpl, cellTemplate: this.vatTPL },
            { prop: 'actions', name: '',
                width: 160, cellTemplate: this.actions, frozenRight: true },
        ];
    }
    checkIfAddress() {
        return this.userService.readUserFromLocalStorage().role !== 'AG' ||
            this.userService.readUserFromLocalStorage().role === 'DI';
    }
    allowUnlockGoogleMaps() {
        return this.currentUser &&
            this.currentUser.role === 'US' &&
            (this.currentUser.userGroup === 'ED' || this.currentUser.userGroup === 'SH');
    }
    unlockGoogleMaps() {
        this.unlockedGoogleMaps = true;
    }
    closeCreateUpdateModal() {
        this.addressCreateUpdateForm.reset();
        this.addressCreateUpdateForm.controls.carrierName.setValue('');
        this.createUpdateRow.close();
        this.unlockedGoogleMaps = false;
    }
    allowEditAnyway() {
        return this.currentUser &&
            this.currentUser.role === 'US' &&
            (this.currentUser.userGroup === 'ED' || this.currentUser.userGroup === 'SH');
    }
    updateAnyway() {
        this.editRowConfirmation.close();
        this.editAddressModal(this.currentAddress, this.currentRef, true);
    }
    editAddressModal(address, ref, forceEdit = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loadingEditStatus = address.idAddress;
            const usedInTreatment = yield this.treatmentsService.existByIdAddress(address.idAddress).toPromise();
            this.loadingEditStatus = -1;
            if (usedInTreatment && !forceEdit) {
                this.currentAddress = address;
                this.currentRef = ref;
                this.editRowConfirmation = this.modalServide.open(this.editRowConfirmationRef, { closeOnNavigation: true, disableClose: true });
                return;
            }
            this.isEdit = true;
            this.addressCreateUpdateForm.patchValue(address);
            this.addressCreateUpdateForm.controls.addressTemp.setValue(address.address);
            this.createUpdateRow = this.modalServide.open(ref, { closeOnNavigation: true, disableClose: true });
            this.createUpdateRow.backdropClick().subscribe(() => {
                this.unlockedGoogleMaps = false;
            });
        });
    }
    createUpdateAddress() {
        const isValid = this.checkRowValidation(this.addressCreateUpdateForm.getRawValue());
        if (!isValid) {
            if (this.addressCreateUpdateForm.controls.address.errors) {
                this.addressCreateUpdateForm.controls.addressTemp.reset();
                this.addressCreateUpdateForm.controls.addressTemp.setErrors({ 'incorrect': true });
            }
            this.addressCreateUpdateForm.markAllAsTouched();
            this.snackBar.open(this.translocoService.translate('REGISTRATION.errorMessageMandatory'), 'X', {
                duration: 3000,
                panelClass: 'warning',
                horizontalPosition: 'right',
                verticalPosition: 'top',
            });
            return;
        }
        const type = AddressTypes.find(x => x.key === this.addressCreateUpdateForm.controls.addressType.value);
        this.addressCreateUpdateForm.controls.addressTypeValue.setValue(type.value);
        if (this.isEdit) {
            this.addresses = this.addresses.map(address => {
                if (address.idAddress === this.addressCreateUpdateForm.controls.idAddress.value) {
                    const newAddress = this.addressCreateUpdateForm.getRawValue();
                    newAddress.blockPhases1 = this.addressCreateUpdateForm.getRawValue().blockPhases1 || false;
                    newAddress.blockNextPhases = this.addressCreateUpdateForm.getRawValue().blockNextPhases || false;
                    return Object.assign({}, address, newAddress);
                }
                return address;
            });
        }
        else {
            const newAddress = this.addressCreateUpdateForm.getRawValue();
            newAddress.blockPhases1 = this.addressCreateUpdateForm.getRawValue().blockPhases1 || false;
            newAddress.blockNextPhases = this.addressCreateUpdateForm.getRawValue().blockNextPhases || false;
            this.addresses = [newAddress, ...this.addresses];
        }
        this.saveAddress.emit(this.addresses);
        this.closeCreateUpdateModal();
    }
    addAddress(ref) {
        this.isEdit = false;
        this.addressCreateUpdateForm.controls.idAddress.setValue(0);
        this.createUpdateRow = this.modalServide.open(ref, { closeOnNavigation: true, disableClose: true });
        this.createUpdateRow.backdropClick().subscribe(() => {
            this.unlockedGoogleMaps = false;
        });
    }
    addAddressProp(ref) {
        this.closeInformModal();
        this.addAddress(ref);
    }
    deleteRow(removeNotSave) {
        if (removeNotSave) {
            this.addresses = [...this.addresses.filter(x => x.idAddress !== 0)];
            this.saveAddress.emit(this.addresses);
            return;
        }
        if (this.selectedAddress) {
            this.addresses = [...this.addresses.filter(x => x.iterator !== this.selectedAddress.iterator)];
            this.saveAddress.emit(this.addresses);
        }
        this.closeDeleteModal();
    }
    closeDeleteModal() {
        this.deleteRowConfirmation.close();
    }
    closeInformModal() {
        this.editRowConfirmation.close();
    }
    recalculate() {
        this.addresses.forEach((x, i) => {
            x = this.rowPrepare(x);
            x.iterator = i;
        });
        this.addresses = [...this.addresses];
        this.tempAddresses = [...this.addresses];
        this.isLoading = false;
    }
    rowPrepare(address) {
        address.enabled = false;
        address.idAddress = address.idAddress ? address.idAddress : 0;
        const type = AddressTypes.find(x => x.key === address.addressType);
        if (type) {
            address.addressTypeValue = type.value;
        }
        return address;
    }
    checkRowValidation(selectedRow, f) {
        this.isRequired = false;
        let result = true;
        if (!selectedRow.addressType) {
            result = false;
        }
        if (!selectedRow.address || selectedRow.address.length > 200) {
            this.selectedRowdAddress = true;
            result = false;
        }
        if (selectedRow.zipCode && selectedRow.zipCode.length > 12) {
            result = false;
        }
        if (selectedRow.city && selectedRow.city.length > 30) {
            result = false;
        }
        if (selectedRow.countryCode && selectedRow.countryCode.length > 60) {
            result = false;
        }
        if (selectedRow.notes && selectedRow.notes.length > 50) {
            result = false;
        }
        if (selectedRow.location && selectedRow.location.length > 30) {
            result = false;
        }
        if (selectedRow.carrierName && selectedRow.carrierName.length > 30) {
            result = false;
        }
        // if (!selectedRow.countryName) {
        //   result = false;
        // }
        if (!selectedRow.countryCode) {
            result = false;
        }
        if (selectedRow.addressType === 'I' && !selectedRow.vat) {
            result = false;
        }
        return result;
    }
    openDeleteRowModal(templateRef, row) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (row.idAddress === 0) {
                this.deleteRow(true);
                return;
            }
            this.loadingDeleteStatus = row.idAddress;
            const usedInTreatment = yield this.treatmentsService.existByIdAddress(row.idAddress).toPromise();
            const shippingAddresses = this.addresses.filter(x => x.addressType === row.addressType);
            if (shippingAddresses.length === 1) {
                let string = '';
                switch (row.addressType) {
                    case 'S':
                        string = 'users.notAbleToDeleteLastShipping';
                        break;
                    case 'R':
                        string = 'users.notAbleToDeleteLastReturn';
                        break;
                    case 'I':
                        string = 'users.notAbleToDeleteLastInvoice';
                        break;
                    default:
                        string = 'users.notAbleToDeleteLastShipping';
                        break;
                }
                this.snackBar.open(this.translocoService.translate(string), 'X', {
                    duration: 3000,
                    panelClass: 'warning',
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                });
                this.loadingDeleteStatus = -1;
                this.cd.detectChanges();
                return;
            }
            this.loadingDeleteStatus = -1;
            this.isAbleToBeDeleted = !usedInTreatment;
            this.selectedAddress = row;
            this.deleteRowConfirmation = this.modalServide.open(templateRef, { closeOnNavigation: true, disableClose: true });
        });
    }
}
